/**
 * Application Routes
 * Centralized route path constants
 */
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  REGISTER: '/register',

  // Main routes
  HOME: '/',
  DASHBOARD: '/dashboard',

  // Leads
  LEADS: '/leads',
  LEADS_NEW: '/leads/new',
  LEADS_EDIT: '/leads/:uuid',

  // Properties
  PROPERTIES: '/properties',
  PROPERTIES_DETAIL: '/properties/:id',

  // Clients
  CLIENTS: '/clients',
  CLIENTS_NEW: '/clients/new',
  CLIENTS_DETAIL: '/clients/:id',

  // Agents
  AGENTS: '/agents',
  AGENTS_DETAIL: '/agents/:id',

  // Deals
  DEALS: '/deals',
  DEALS_NEW: '/deals/new',
  DEALS_DETAIL: '/deals/:id',

  // Users (superadmin only)
  USERS: '/users',
  USERS_DETAIL: '/users/:id',
  ACTIVITY_LOGS: '/activity-logs',

  // Settings (superadmin only)
  SETTINGS: '/settings',
  SETTINGS_GLOBAL: '/settings/global',
  SETTINGS_PAYMENT_PACKAGES: '/settings/payment-packages',
  SETTINGS_DEVELOPERS: '/settings/developers',
  SETTINGS_RESIDENTIAL_COMPLEXES: '/settings/residential-complexes',
  SETTINGS_STREET_TYPES: '/settings/street-types',
  SETTINGS_DISTRICTS_BIG: '/settings/districts-big',
  SETTINGS_DISTRICTS: '/settings/districts',
  SETTINGS_SUBWAY: '/settings/subway',
  SETTINGS_STREETS: '/settings/streets',

  PROFILE: '/profile',
}

/**
 * Build route path with params
 */
export const buildRoute = (route, params = {}) => {
  let path = route
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value)
  })
  return path
}

export default ROUTES
